import {HttpRequest} from "../utils/httpRequest";

let SysRole = {
    /**
     * 获取角色数据
     * @returns {*}
     */
    getRoles() {
        return HttpRequest.getRequest({
            url: '/sys/role/all',
            method: 'get'
        });
    },
    /**
     * 列表数据
     * @param params
     * @returns {*}
     */
    getRoleList(params) {
        return HttpRequest.getRequest({
            url: '/sys/role/list',
            method: 'get',
            data: params
        });
    },
    /**
     * 角色信息
     * @param id
     * @returns {*}
     */
    getRoleInfo(id) {
        return HttpRequest.getRequest({
            url: '/sys/role/info/' + id,
            method: 'get'
        });
    },
    /**
     * 验证
     * @param params
     * @returns {*}
     */
    getRoleByName(params) {
        return HttpRequest.getRequest({
            url: '/sys/role/validate',
            method: 'get',
            data: params
        });
    },
    /**
     * 新增或编辑数据
     * @param datas
     * @param type
     * @returns {*}
     */
    addOrUpdateRole(datas, type) {
        return HttpRequest.getRequest({
            url: '/sys/role/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除数据
     * @param params
     * @returns {*}
     */
    deleteRole(params) {
        return HttpRequest.getRequest({
            url: '/sys/role/delete',
            method: 'get',
            data: params
        });
    }

};
export {SysRole}
